import React from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Button from "../../../../../../../common/Button";
import Grammar from "../../../../../../learning/presentational/body/view/directive/tip/Grammar";

const Tip = ( props ) => {
  const { t } = useTranslation();
  const questionView = useSelector( state => state.questionView );

  return (
    <div className="btn-viewopen-wrap">
      <Button className={ clsx( 'btn-viewopen', questionView.isShowTip && 'on' ) } onClick={ props.onShow }>
        {t('LC_05_20.msg009')}
      </Button>
      { questionView.isShowTip && <Grammar /> }
    </div>
  );

};

export default Tip;
